"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sampleWeighted = exports.vec = exports.shuffle = exports.sampleAndRemove = exports.sample = exports.randomIndex = exports.sign = exports.chance = exports.b = exports.i = exports.fj = exports.fs = exports.f = exports.setSeed = void 0;
var arrayUtils_sidecar_1 = require("@engine/arrayUtils-sidecar");
var assert_sidecar_1 = require("./assert-sidecar");
var imports_1 = require("./imports");
//https://www.npmjs.com/package/fast-random
// import { random } from 'fast-random'
var random = require('fast-random');
var seed = Date.now();
var r = _setSeed(seed);
function _setSeed(num) {
    var _r = random(num);
    return _r;
}
function setSeed(num) {
    r = _setSeed(num);
}
exports.setSeed = setSeed;
function f(min, max) {
    return min + (max - min) * r.nextFloat();
}
exports.f = f;
function fs(max) {
    var min = -max;
    return min + (max - min) * r.nextFloat();
}
exports.fs = fs;
function fj(n, jitter) {
    return n + fs(jitter * n);
}
exports.fj = fj;
function i(min, max) {
    return min + (r.nextInt() % (max - min + 1));
}
exports.i = i;
var b = function () {
    return chance(0.5);
};
exports.b = b;
function chance(factor) {
    return r.nextFloat() <= factor;
}
exports.chance = chance;
function sign() {
    return chance(0.5) ? 1 : -1;
}
exports.sign = sign;
function randomIndex(arr) {
    assert_sidecar_1.assert.t(arr.length > 0);
    var idx = i(0, arr.length - 1);
    return idx;
}
exports.randomIndex = randomIndex;
function sample(arr) {
    return arr[randomIndex(arr)];
}
exports.sample = sample;
function sampleAndRemove(arr) {
    assert_sidecar_1.assert.t(arr.length > 0);
    var idx = i(0, arr.length - 1);
    var s = arr[idx];
    // arr.splice(idx, 1)
    arrayUtils_sidecar_1.arrayUtils.fastSplice(arr, idx, 1);
    return s;
}
exports.sampleAndRemove = sampleAndRemove;
function shuffle(arr) {
    return imports_1.l.shuffle(arr);
}
exports.shuffle = shuffle;
function vec() {
    var x = f(-1, 1);
    var y = f(-1, 1);
    // let v = Vec2(x, y)
    // v.normalize()
    return { x: x, y: y };
}
exports.vec = vec;
// move this
function sampleWeighted(arr) {
    if (arr.length === 0) {
        assert_sidecar_1.assert.failed('sampleWeighted: empty array');
        // return null
    }
    var total = 0;
    for (var i_1 = 0; i_1 < arr.length; i_1++) {
        total += arr[i_1].weight;
    }
    var randomVal = f(0, total);
    var runningTotal = 0;
    for (var i_2 = 0; i_2 < arr.length; i_2++) {
        runningTotal += arr[i_2].weight;
        if (randomVal <= runningTotal) {
            return arr[i_2].value;
        }
    }
    assert_sidecar_1.assert.failed('sampleWeighted: failed to sample');
}
exports.sampleWeighted = sampleWeighted;
// export interface IChances {
//   [key: string]: number
// }
// export interface IChancesBakedItem {
//   min: number
//   max: number
//   key: string
//   weight: number
// }
// export function bakeChances(
//   chances: IChances,
//   max: number = 100,
// ): IChancesBakedItem[] {
//   let baked: IChancesBakedItem[] = []
//   let total = 0
//   l.forEach(chances, (c, cIdx) => {
//     total += c
//   })
//   if (total > max) {
//     max = total
//   }
//   let v = 0
//   l.forEach(chances, (c, cIdx) => {
//     let w = c / max
//     let v2 = w + v
//     baked.push({
//       min: v,
//       max: v2,
//       key: cIdx,
//       weight: w,
//     })
//     v = v2
//   })
//   return baked
// }
// export function randomChances(
//   chances: IChancesBakedItem[],
//   _default: string = '',
// ): string {
//   let v = f(0, 1)
//   for (let i = 0; i < chances.length; i++) {
//     let c = chances[i]
//     if (v >= c.min && v < c.max) {
//       return c.key
//     }
//   }
//   return _default
// }
